// utils/cache-data.js
const TypeChecker = require('./type-checker');

const setCache = (key, value, isJson = true) => {
  if (value) {
    if (isJson) {
      value = JSON.stringify(value);
    } else if (typeof value !== 'string') {
      value = String(value).toString;
    }
    localStorage.setItem(key, value);
  }
};
const getCache = (key) => {
  const value = localStorage.getItem(key);
  if (value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      console.error('getCache error: ', error.message);
      return null;
    }
  }
  return null;
};

// Clean define cache
export const cleanCaches = () => {
  // localStorage.clear(); // Clears all data
  localStorage.removeItem('cache_plates');
  localStorage.removeItem('cache_legal_plates');
  localStorage.removeItem('cache_services');
  localStorage.removeItem('cache_partners');
  localStorage.removeItem('cache_locations');
  localStorage.removeItem('cache_car_partners');
  localStorage.removeItem('cache_groups');
  localStorage.removeItem('cache_status');
  localStorage.removeItem('cache_trackings');
  localStorage.removeItem('cache_degree');
};

// PLEASE review and test before use
export const clearAllCaches = () => {
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('cache_')) {
      localStorage.removeItem(key);
    }
  });
};

// Plates or cars
export const getCachePlates = () => {
  // return getCache('cache_plates');
  return null;
};
export const setCachePlates = (data) => {
  if (TypeChecker.isArray(data)) {
    // setCache('cache_plates', data);
  }
};
export const getCacheLegalPlates = () => {
  return getCache('cache_legal_plates');
};
export const setCacheLegalPlates = (data) => {
  if (TypeChecker.isArray(data)) {
    setCache('cache_legal_plates', data);
  }
};

// Car and Partner
export const getCacheCarPartner = () => {
  const result = getCache('cache_car_partners');
  return result || {};
};
export const setCacheCarPartner = (data) => {
  if (TypeChecker.isObject(data)) {
    setCache('cache_car_partners', data);
  }
};

// Services
export const getCacheServices = () => {
  // return getCache('cache_services');
  return null;
};
export const setCacheServices = (data) => {
  if (TypeChecker.isArray(data)) {
    // setCache('cache_services', data);
  }
};

// Partners
export const getCachePartners = () => {
  return getCache('cache_partners');
};
export const setCachePartners = (data) => {
  if (TypeChecker.isObject(data)) {
    setCache('cache_partners', data);
  }
};

// Groups
export const getCacheGroups = () => {
  return getCache('cache_groups');
};
export const setCacheGroups = (data) => {
  if (TypeChecker.isObject(data)) {
    setCache('cache_groups', data);
  }
};

// Locations or Zoon
export const getCacheLocations = () => {
  return getCache('cache_locations');
};
export const setCacheLocations = (data) => {
  if (TypeChecker.isArray(data)) {
    setCache('cache_locations', data);
  }
};

// Checkin
export const getCacheCheckin = () => {
  const cache = getCache('cache_checkin');
  return cache;
};
export const setCacheCheckin = (data) => {
  if (data) {
    // if(data !== null && typeof data === 'object') // Check data is object if need
    let { tms, car } = data;
    if (tms) {
      if(tms.id === 0){
        tms = getCache('cache_checkin');
        if (tms) {
          delete tms.id;
          delete tms.expired;
        }
      }else{
        const milliseconds = new Date().getTime();
        tms.expired = milliseconds + (3600000 * 4); // Expired in 4 hours
      }
      // Update origin object
      setCache('cache_checkin', tms);
    } else if (car) {
      // Check before update
      const value = getCache('cache_checkin');
      if (!value || !value.id || !value.id > 0) {
        setCache('cache_checkin', { car });
      }
      // else{
      //   value.car = car;
      //   setCache('cache_checkin', value);
      // }
    }
  } else {
    // Keep last car info
    let value = getCache('cache_checkin');
    if (value) {
      delete value.id;
      setCache('cache_checkin', value);
    }
  }
  // Test data after set
  //getCacheCheckin();
};

// Status cache
export const getCacheStatus = () => {
  return getCache('cache_status');
};
export const setCacheStatus = (data) => {
  if (TypeChecker.isObject(data)) {
    setCache('cache_status', data);
  }
};

// Tracking cache
export const getCacheTrackings = () => {
  return getCache('cache_trackings');
};
export const setCacheTrackings = (data) => {
  if (TypeChecker.isArray(data)) {
    setCache('cache_trackings', data);
  }
};

// Degree cache
export const getCacheDegree = () => {
  return getCache('cache_degree');
};
export const setCacheDegree = (data) => {
  if (TypeChecker.isObject(data)) {
    setCache('cache_degree', data);
  }
};